import React from 'react';

const PoweredBy = ({ logoUrl, height = 24, opacity = 0.8 }) => {
  return (
    <div 
      className="flex items-center transition-all duration-300 ease-in-out"
      style={{ opacity: opacity }}
    >
      <span className="text-[9px] uppercase tracking-[0.2em] text-brand-muted font-semibold whitespace-nowrap">
        Powered by
      </span>
      
      <img 
        src={logoUrl} 
        alt="Brand Logo" 
        style={{ height: `${height}px` }}
        className="w-auto object-contain brightness-100 hover:brightness-110"
      />
    </div>
  );
};

export default PoweredBy;